import Vue from 'vue';
import router from '@/router/index';
import * as Sentry from '@sentry/vue';
import CONFIG from '@/config';
import { getAppVer } from '@/utils';

export const isSentryReportError = (event) => {
    const exposeHeader = event?.extra?.__serialized__?.header?.['access-control-expose-headers'] ?? '';
    if (exposeHeader.includes('x-sentry')) {
        return true;
    }
    return false;
};
export const isDomainBlocked = (event) => {
    return event?.extra?.__serialized__?.errorMessage?.includes('域名白名单');
};

const BASE_CONFIG = {
    list: ['dev', 'development', 'betadev', 'beta', 'betaa', 'betab', 'betac', 'pre', 'gray', 'prod', 'production'],
    env: {
        dev: 'qa0',
        development: 'qa0',
        betadev: 'qa0',
        beta: 'qa',
        betaa: 'qa2',
        betab: 'qa3',
        betac: 'qa4',
        betad: 'qa5',
        pre: 'pre',
        gray: 'pre',
        prod: 'prod',
        production: 'prod',
    },
    dsn: {
        qa: 'https://7bb4fbec4e81245c5242b7d4833f94b3@qa-sentry.at-our.com/10',
        production: 'https://675be27c4a454d4e16d3d12d0e9bb33c@sentry-prod.yaduo.com/12',
    },
};

export const initSentry = function() {
    const CONFIG_ENV = CONFIG.ENV;
    console.log('CONFIG_ENV', CONFIG, process.env);
    if (BASE_CONFIG.list.indexOf(CONFIG_ENV) !== -1) {
        const isProdEnv = ['production', 'pre'].includes(CONFIG_ENV);
        const dsn = isProdEnv ? BASE_CONFIG.dsn.production : BASE_CONFIG.dsn.qa;
        const environment = BASE_CONFIG.env[CONFIG_ENV] || 'qa0';
        console.log(`environment | process.env.REACT_APP_ENVIRONMENT: ${environment} | ${CONFIG_ENV}`);

        Sentry.init({
            Vue,
            dsn,
            environment,
            // 标记版本，便于聚合与回滚对比
            release: getAppVer() || '',
            sampleRate: 1,
            // sendDefaultPii: true,
            beforeSend(event) {
                if (isSentryReportError(event) || isDomainBlocked(event)) {
                    return null;
                }
                return event;
            },
            integrations: [
                // Vue 2 集成：自动接管 Vue 错误与组件信息
                Sentry.vueIntegration({
                    tracingOptions: {
                    // 扩展追踪钩子，便于排查渲染阶段问题
                        hooks: ['create', 'mount', 'update', 'destroy', 'activate'],
                        // 如需更精细的组件性能追踪，开启后可产生较多数据
                        trackComponents: true,
                    },
                }),
                // 浏览器性能 + 路由追踪
                Sentry.browserTracingIntegration({
                    idleTimeout: 2000,
                    router,
                }),

                Sentry.breadcrumbsIntegration({
                    console: false,
                    dom: true,
                    fetch: true,
                    history: true,
                    xhr: true,
                }),
                Sentry.contextLinesIntegration(),
                // 捕获 Error 自定义字段，便于查看错误对象上的额外信息
                Sentry.extraErrorDataIntegration({ depth: 5 }),
            ],
            tracesSampleRate: isProdEnv ? 0.1 : 1.0,
        });
    }
};

export default Sentry;
